import React from 'react'

import { Edit, LocationOn } from '@mui/icons-material'
import { Box, Divider, IconButton, Typography } from '@mui/material'

import Avatar from '../../../../shared/components/Avatar/Avatar.component'

import { RecipientDetailsValues } from '../../CreateFulfillmentOrder.types'
import styles from './FulfillmentRecipientCard.styles'
import { FulfillmentRecipientCardProps } from './FulfillmentRecipientCard.types'

const formatAddress = (recipient: RecipientDetailsValues): string => {
  const parts: string[] = []

  if (recipient.streetAddress?.trim()) parts.push(recipient.streetAddress.trim())
  if (recipient.city?.trim()) parts.push(recipient.city.trim())
  if (recipient.stateProvince?.trim() || recipient.postalCode?.trim()) {
    parts.push([recipient.stateProvince?.trim(), recipient.postalCode?.trim()].filter(Boolean).join(' '))
  }
  if (recipient.country?.trim()) parts.push(recipient.country.trim())

  return parts.join(', ')
}

const hasRecipientDisplayData = (recipient: RecipientDetailsValues | null): boolean =>
  !!(
    recipient &&
    (recipient.firstName?.trim() ||
      recipient.lastName?.trim() ||
      recipient.streetAddress?.trim() ||
      recipient.city?.trim() ||
      recipient.country?.trim())
  )

const FulfillmentRecipientCard: React.FC<FulfillmentRecipientCardProps> = (props) => {
  const { recipient, showEditIcon, onEditClick } = props

  if (!recipient || !hasRecipientDisplayData(recipient)) {
    return null
  }

  const addressLine = formatAddress(recipient)

  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Typography sx={styles.titleText}>Your Recipient</Typography>

        {showEditIcon && onEditClick && (
          <IconButton size="small" sx={styles.editIcon} onClick={onEditClick} aria-label="Edit recipient details">
            <Edit sx={{ fontSize: 16 }} />
          </IconButton>
        )}
      </Box>

      <Divider sx={styles.divider} />

      <Box sx={styles.contentRow}>
        <Box sx={styles.avatarWrapper}>
          <Avatar firstName={recipient.firstName} lastName={recipient.lastName} size="medium" noRightMargin />
        </Box>

        <Box sx={styles.infoColumn}>
          <Typography sx={styles.nameText}>
            {`${recipient.firstName || ''} ${recipient.lastName || ''}`.trim()}
          </Typography>

          {addressLine && (
            <Box sx={styles.addressRow}>
              <LocationOn sx={styles.locationIcon} />
              <Typography sx={styles.addressText}>{addressLine}</Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default FulfillmentRecipientCard
